// src/hooks/useActivity.js
import {useQuery} from 'react-query';
import {fetchActivity} from "../api/activityApi";

export const useActivity = (pageNumber, pageSize) => {
    return useQuery(['activityInfo', pageNumber, pageSize], () => fetchActivity(pageNumber, pageSize), {
        refetchOnWindowFocus: false, // 根據需求調整
    });
};
